export default "__VITE_ASSET__OryDXS8Q__"